import { render, staticRenderFns } from "./BrandCenters.vue?vue&type=template&id=01de1c4b&scoped=true"
import script from "./BrandCenters.vue?vue&type=script&lang=js"
export * from "./BrandCenters.vue?vue&type=script&lang=js"
import style0 from "./BrandCenters.vue?vue&type=style&index=0&id=01de1c4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01de1c4b",
  null
  
)

export default component.exports